import {
  Card,
  CardHeader,
} from "reactstrap";
import { useState, useEffect } from "react";

import { EXPENSE_REPORT } from "../../../services/CONSTANTS";
import { getApiDataService } from "../../../services/apiServices";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { DataTable, FilterBar } from "components/shared";

const EXPENSE_COLUMNS = [
  { key: "index", label: "#" },
  { key: "date", label: "Date" },
  { key: "amount", label: "Amount" },
];

const ExpenseReport = () => {
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [startDate, setStartDate] = useState(
    moment().startOf("month").toISOString()
  );
  const [endDate, setEndDate] = useState(moment().endOf("month").toISOString());

  const [dateChangeEvent, setDateChangeEvent] = useState(true);

  let handleExpenseDateChange = (start, end) => {
    setStartDate(start.toISOString());
    setEndDate(end.toISOString());
    setDateChangeEvent(!dateChangeEvent);
  };

  useEffect(() => {
    fetchReport();
  }, [dateChangeEvent]);

  let fetchReport = async () => {
    setIsLoading(true);
    try {
      let res = await getApiDataService(
        `${EXPENSE_REPORT}?start_date=${startDate}&end_date=${endDate}`
      );
      setReports(res.data || []);
    } catch (err) {
      console.log("Error Loading Expense Report:", err);
      setReports([]);
    }
    setIsLoading(false);
  };

  return (
    <>
      <Card className="shadow">
        <CardHeader className="border-0">
          <FilterBar title="Expense Reports">
            <DateRangePicker onCallback={handleExpenseDateChange}>
              <input
                className="form-control akh-filter-width"
                placeholder="Select date range"
                aria-label="Date range"
              />
            </DateRangePicker>
          </FilterBar>
        </CardHeader>
        <DataTable
          columns={EXPENSE_COLUMNS}
          data={reports}
          isLoading={isLoading}
          emptyMessage="No Data"
          renderRow={(item, index) => (
            <tr key={item?.date || index}>
              <td>{index + 1}</td>
              <td>{item.date}</td>
              <td className="font-mono">
                {item.amount.toLocaleString("en-US")} MMK
              </td>
            </tr>
          )}
        />
      </Card>
    </>
  );
};

export default ExpenseReport;
